import React from 'react'
import { FileText } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminClaims = () => {
  return (
    <GenericTable
      tableName="claims"
      title="Claims"
      icon={FileText}
      iconColor="blue"
      searchFields={['claim_number', 'claim_stage', 'total_bill_amount', 'claim_type', 'claim_category']}
      hiddenFields={['claim_id', 'created_at', 'updated_at']}
      primaryKey="claim_id"
      defaultFields={['claim_number', 'claim_type', 'claim_stage', 'total_bill_amount', 'approval_status', 'claim_date', 'customer_name', 'hospital_name']}
      addFields={['claim_type', 'claim_category', 'claim_stage', 'claim_mode', 'total_bill_amount', 'customer_id', 'hospital_id', 'claim_date', 'approval_status']}
      editFields={[
        'claim_type', 'claim_category', 'claim_stage', 'claim_mode', 'total_bill_amount', 
        'approval_status', 'claim_description', 'claim_date', 'incident_date', 
        'treatment_details', 'doctor_name', 'hospital_name', 'approval_date', 'rejection_reason',
        'settlement_amount', 'deductible_amount', 'co_payment', 'final_amount'
        // Excluded: claim_id, claim_number, created_at, updated_at
      ]}
    />
  )
}

export default AdminClaims